import React from 'react'
import { useSelector } from 'react-redux'
import './pdcaHeaderContexto.scss'

export default () => {
  const {
    projetoNome,
    empresaPdcaNome
  } = useSelector(state => state.pdcaState.pdcaBaseState)

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  return (
    <div className='box-pdca-header-contexto'>
      <div className='box-pdca-header-contexto-meta'>
        <div className='box-pdca-header-contexto-item'>
          <span className='box-pdca-header-contexto-label'>{nls.projectLabel}:</span>
          <span className='box-pdca-header-contexto-value'>{projetoNome || '-'}</span>
        </div>

        <div className='box-pdca-header-contexto-item'>
          <span className='box-pdca-header-contexto-label'>{nls.companyPdcaLabel}:</span>
          <span className='box-pdca-header-contexto-value'>{empresaPdcaNome || '-'}</span>
        </div>
      </div>
    </div>
  )
}